module.exports = __webpack_public_path__ + "img/dddtl-logo.30021e7a.png";